import axios from "axios";

// Always use API_URL (not SOCKET_URL)
const apiUrl = process.env.REACT_APP_SOCKET_URL || "http://localhost:5000/";

const axiosinstance = axios.create({
  baseURL: `${apiUrl}api/v1/`,
});

axiosinstance.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("accessToken");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error),
);

axiosinstance.interceptors.response.use(
  (response) => response.data,
  (error) => {
    console.log("AXIOS ERROR:", error);

    return Promise.reject({
      code: error.response?.status || 500,
      message: error.response?.data?.message || error.message || "Server Error",
      data: null,
    });
  },
);

export default axiosinstance;
